module.exports = __webpack_public_path__ + "static/media/060-israel.33cc68a7.svg";